import React from 'react';
import { noop } from 'lodash-es';
import styled from 'styled-components';

import FjModal, { fjModalSizes } from '../fj-modal';

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  padding: 0 20px;
`;

export interface FjWizardStep {
  component: React.ReactNode;
  title?: React.ReactNode;
  valid?: boolean;
}

export interface FjWizardProps {
  steps: FjWizardStep[];
  onSubmit: () => void;
  className?: string;
  showX?: boolean;
  onClickX?: () => void;
  modalComponent?: typeof FjModal;
  windowSize?: string;
  allowScroll?: boolean;
}

interface FjWizardState {
  step: number;
}

export default class FjWizard extends React.Component<FjWizardProps, FjWizardState> {
  static defaultProps = {
    showX: false,
    onClickX: noop,
    modalComponent: FjModal,
    windowSize: fjModalSizes.XL,
    allowScroll: false,
  };

  constructor(props: FjWizardProps) {
    super(props);
    this.state = {
      step: 0,
    };
  }

  goToNext = (): void => {
    this.setState((prevState) => ({
      step: prevState.step + 1,
    }));
  };

  goToPrevious = (): void => {
    this.setState((prevState) => ({
      step: prevState.step - 1,
    }));
  };

  isLastStep = (): boolean => this.state.step === this.props.steps.length - 1;

  render(): React.ReactNode {
    const Modal = this.props.modalComponent as typeof FjModal;
    const step = this.props.steps[this.state.step];
    const valid = step.valid !== undefined ? step.valid : true;
    return (
      <Modal
        className={this.props.className}
        title={step.title}
        size={this.props.windowSize}
        accept={{
          text: this.isLastStep() ? 'Finish' : 'Next',
          callback: valid && this.isLastStep() ? this.props.onSubmit : this.goToNext,
          disabled: !valid,
        }}
        cancel={{
          text: 'Previous',
          callback: this.state.step ? this.goToPrevious : noop,
          disabled: !this.state.step,
        }}
        showX={this.props.showX}
        onClickX={this.props.onClickX}
        allowScroll={this.props.allowScroll}
      >
        <ContentWrapper>{step.component}</ContentWrapper>
      </Modal>
    );
  }
}
